/**
 * Info Component.
 * It helps to show the error and success information.
 * Glyph icon of kepler will be rendered if class provided.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Glyph } from 'kepler';

// Return Large Glyph Icon and Type through class.
const getIcon = (iconClass) => {
  if (iconClass) {
    return <Glyph icon={iconClass} size="large" className="info-icon" />;
  }
  return null;
};

//
const Info = ({ iconClass, title, description }) => (
  <div className="info text-center">
    {getIcon(iconClass)}
    <h1>{title}</h1>
    <p>{description}</p>
  </div>
);

// Info Props Types.
Info.propTypes = {
  iconClass: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

// Info Props default values.
Info.defaultProps = {
  iconClass: '',
  title: '',
  description: '',
};

export default Info;



// WEBPACK FOOTER //
// ./contactUs/components/common/Info.js